import { htmlPageRouteMap } from "../data/mockData";

const routeReplacements = new Map(Object.entries(htmlPageRouteMap));

export function extractHtmlFragment(rawHtml, selector) {
  if (!rawHtml) return "";

  const document = new DOMParser().parseFromString(rawHtml, "text/html");
  const element = selector ? document.querySelector(selector) : document.body;

  return element?.innerHTML || document.body.innerHTML || "";
}

export function rewriteHtmlContent(html) {
  if (!html) return "";

  const assetRewritten = html
    .replace(/(href|src)=["']template\//g, '$1="/template/')
    .replace(/(href|src)=["']\.\/template\//g, '$1="/template/');

  return assetRewritten.replace(/href=["']([^"'#?]+\.html)([^"']*)["']/g, (match, fileName, suffix = "") => {
    const route = routeReplacements.get(fileName) || fileName.replace(/\.html$/, "");
    return `href="${route}${suffix}"`;
  });
}

export function toSafeText(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
